module.exports = __webpack_public_path__ + "static/media/laurel-crown.00b6e803.svg";